import { render, staticRenderFns } from "./CardPromoterCreate.vue?vue&type=template&id=0aabd3b8&scoped=true&"
import script from "./CardPromoterCreate.vue?vue&type=script&lang=js&"
export * from "./CardPromoterCreate.vue?vue&type=script&lang=js&"
import style0 from "./CardPromoterCreate.vue?vue&type=style&index=0&id=0aabd3b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aabd3b8",
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn,QIcon});
